import axios from 'axios'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { URL_BASE } from '../../constants/configurations'
// import { actionUserLogout } from '../../redux/actions/user'

/**
   * Hook for create fetch api rest
   *
   *
   * @author   ehernandez
   * @param    {String}   endpoint  endpoint to call
   */
export const useMutation = (endpoint) => {
  const [loading, setLoading] = useState(false)
  const { token } = useSelector(state => state.userReducer)
  // const dispatch = useDispatch()

  /**
   * Custom fetch mutation for axios
   *
   *
   * @author   ehernandez
   * @param    {Object} data
   * @param    {String}   data.method   method api
   * @param    {String}   data.data     info to send to body
   * @param    {String}   data.addToURL
   */
  const fetch = async ({ method = 'post', data, addToURL = '' }) => {
    setLoading(true)
    const URL = URL_BASE
    const config = {
      method: method,
      url: URL + endpoint + addToURL
    }

    if (data) {
      config.data = data
    }

    config.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return await axios(config)
      .then((response) => {
        setLoading(false)
        if (response.status !== 200) {
          return {
            success: false,
            error: response
          }
        }
        return {
          success: true,
          data: response.data
        }
      })
      .catch(err => {
        console.log(err.response)
        const { status } = err.response
        if (status === 401) {
          // dispatch(actionUserLogout())
        }
        setLoading(false)
        return {
          success: false,
          error: err?.response?.data
        }
      })
  }

  return [fetch, { loading }]
}
